import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { Loader } from 'react-feather';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { Card } from '../../../components/Card';
import { Cell, List, Row } from '../../../components/List';
import { getPropByName } from '../../../utils/props';
import { selectWork } from '../../Api/selectors';
import { fetchInvoice } from '../../Invoices/actions';
import { REQUEST_INVOICE } from '../../Invoices/constants';
import { selectInvoiceById } from '../../Invoices/selectors';

import { getDate } from '../../Vehicles/helpers';
import { Link } from 'react-router-dom';
import { InvoiceStatus } from '../../Invoices/components/InvoiceStatus';
import { fetchWebloginVehicleInvoice } from '../actions';
import { WEBLOGIN_FETCH_VEHICLE_INVOICE } from '../constants';

const Container = styled.div`
  font-size: 14px;

  .cell:first-child {
    text-transform: capitalize;
  }

  .status-label {
    width: fit-content;
  }
  .info-card {
    min-width: 260px;
    width: 100%;
  }
  .info-card {
    min-width: 380px;
    width: 100%;
  }
`;

const STATE = {
  invoice: null,
};
/* eslint-disable react/prefer-stateless-function */
class WebloginVehicleOutgoingInvoiceCardComp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
    });
  }

  componentDidMount() {
    this.props.vehicle?.outgoing_invoice &&
      this.props.fetch(res => {
        if (res.id) {
          this.setState({ invoice: res });
        }
      });
  }

  componentDidUpdate(prevProps, prevState) {
    this.props.vehicle?.outgoing_invoice &&
      !this.state.invoice &&
      this.props.fetch(res => {
        if (res.id) {
          this.setState({ invoice: res });
        }
      });
  }

  get extraTotalEmount() {
    let total = 0;
    this.state.invoice?.invoiceSubjects.map(subject =>
      subject.type == 'cost' ? (total += subject.price) : (total = total),
    );

    return total;
  }

  render() {
    const vehicle = this.props.vehicle;

    const { invoice } = this.state;
    let typesArr = [
      'client',
      'seller',
      'total_amount',
      'extra_total_amount',
      'outgoing_invoice_generated_date',
      'outgoing_invoice_finalized_date',
      'paymentStatus',
    ];

    if (this.props.work) return <Loader small="true" />;
    if (this.props.vehicle?.outgoing_invoice && !invoice) return <Loader small="true" />;

    let sellerName =
      `${getPropByName(invoice?.userSeller, 'name')} ${getPropByName(invoice?.userSeller, 'surname')}`.trim() ||
      invoice?.userSeller?.email_address ||
      '';

    return (
      <Container>
      <Card className="vehicle-info-card info-card data">
      
          <h2 className="card-title mb-2 text-muted">{this.lbl('vehicle.info.finance.outgoing_invoice_data')}</h2>
          {invoice && (
            <List>
              {typesArr.map(property => {
                if (property == 'client') {
                  return (
                    invoice?.outgoingCompany?.id && (
                      <Row key={property}>
                        <Cell>{this.lbl(`vehicle.info.finance.${property}`)}</Cell>
                        <Cell>{`${getPropByName(invoice?.outgoingCompany, 'name') || ''}`}</Cell>
                      </Row>
                    )
                  );
                }

                if (property == 'seller') {
                  return (
                    invoice?.userCreator?.id && (
                      <Row key={property}>
                        <Cell>{this.lbl(`vehicle.info.finance.${property}`)}</Cell>
                        <Cell>{sellerName}</Cell>
                      </Row>
                    )
                  );
                }

                if (property == 'total_amount') {
                  return (
                    invoice?.id && (
                      <Row key={property}>
                        <Cell>{this.lbl(`vehicle.info.finance.${property}`)}</Cell>
                        <Cell>{invoice?.financialTotalAmount}</Cell>
                      </Row>
                    )
                  );
                }

                if (property == 'extra_total_amount') {
                  return (
                    this.extraTotalEmount && (
                      <Row key={property}>
                        <Cell>{this.lbl(`vehicle.info.finance.${property}`)}</Cell>
                        <Cell>{this.extraTotalEmount}</Cell>
                      </Row>
                    )
                  );
                }
                if (property == 'outgoing_invoice_generated_date') {
                  return (
                    this.props.vehicle[property] && (
                      <Row key={property}>
                        <Cell>{this.lbl(`vehicle.info.finance.${property}`)}</Cell>
                        <Cell>{getDate(this.props.vehicle[property])}</Cell>
                      </Row>
                    )
                  );
                }
                if (property == 'outgoing_invoice_finalized_date') {
                  return (
                    this.props.vehicle[property] && (
                      <Row key={property}>
                        <Cell>{this.lbl(`vehicle.info.finance.${property}`)}</Cell>
                        <Cell>{getDate(this.props.vehicle[property])}</Cell>
                      </Row>
                    )
                  );
                }

                if (property == 'paymentStatus') {
                  return (
                    <Row key={property}>
                      <Cell>{this.lbl(`vehicle.info.finance.payment_status`)}</Cell>
                      <Cell>
                        <InvoiceStatus className="status-label" status={invoice?.status?.name} />
                      </Cell>
                    </Row>
                  );
                }
              })}
              <Row>
                <Cell>{this.lbl(`vehicle.property.uitgaande_vrijwaring`)}</Cell>
                <Cell>{getDate(vehicle?.sales_release_date)}</Cell>
              </Row>
            </List>
          )}
        
      </Card>
      </Container>
    );
  }
}

WebloginVehicleOutgoingInvoiceCardComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    work: selectWork(`${WEBLOGIN_FETCH_VEHICLE_INVOICE}-${ownProps.vehicle?.id}`),
    invoice: selectInvoiceById(ownProps.vehicle?.outgoing_invoice),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    fetch(callback) {
      dispatch(fetchWebloginVehicleInvoice(ownProps.vehicle?.id, ownProps.vehicle?.outgoing_invoice, callback));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const WebloginVehicleOutgoingInvoiceCard = compose(withConnect, withRouter)(WebloginVehicleOutgoingInvoiceCardComp);
